module.exports = __webpack_public_path__ + "img/photo-car-salesman-giving-car-keys-from-a-silver-new-car.14a10ba1.png";